import React from "react"
import { Link } from "gatsby"
import "./index.scss"

import { BlogHeaderTitle } from "../Common"
import { ThemeToggle } from "../ThemeToggle";

export const Header = ({ data }) => (
    <div className="flex-header">
        <Link to={`/`} className="flex-header-title">
            <BlogHeaderTitle title={data.site.siteMetadata.title} />
        </Link>
        <div className="flex-header-content">
            {/* TODO ADD SEARCH HERE */}
            <Link to={`/about/`} className={"menu-item about-menu-item"}>
                {"About"}
            </Link>
            <ThemeToggle />
        </div>
    </div>
)
